export default function PreFooter() {
    return (
        <div className="flex flex-col items-center justify-center">
            <div className="flex flex-col items-center justify-between ">
                <div className="lg:text-center text-[16px] xl:text-[32px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[60px] xl:mt-[120px]">
                    Ключ Астром — ИИ, который оптимизирует ваши бизнес-процессы, делает цифровой опыт предсказуемым и обеспечивает вашему цифровому бизнесу конкурентное преимущество.
                </div>                
            </div>
        </div>
    );
}